import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useRouter, type RouteLocationNormalized } from 'vue-router'

const GLOBAL_DIRTY_SOURCE = '__global'

export const useUnsavedChangesStore = defineStore('unsavedChanges', () => {
  const isDirty = ref(false)
  const showConfirmDialog = ref(false)
  const pendingRoute = ref<RouteLocationNormalized | null>(null)
  const dirtySources = ref(new Set<string>())

  const recomputeIsDirty = () => {
    isDirty.value = dirtySources.value.size > 0
  }

  const setDirty = (value: boolean) => {
    if (value) {
      dirtySources.value.add(GLOBAL_DIRTY_SOURCE)
    } else {
      dirtySources.value.delete(GLOBAL_DIRTY_SOURCE)
    }
    recomputeIsDirty()
  }

  const setSourceDirty = (sourceId: string, dirty: boolean) => {
    if (dirty) {
      dirtySources.value.add(sourceId)
    } else {
      dirtySources.value.delete(sourceId)
    }
    recomputeIsDirty()
  }

  const clearDirty = () => {
    dirtySources.value.clear()
    recomputeIsDirty()
  }

  const checkNavigation = (to: RouteLocationNormalized) => {
    if (isDirty.value) {
      pendingRoute.value = to
      showConfirmDialog.value = true
      return false
    }
    return true
  }

  const confirmLeave = () => {
    const router = useRouter()
    clearDirty()
    showConfirmDialog.value = false

    if (pendingRoute.value) {
      router.push(pendingRoute.value)
      pendingRoute.value = null
    }
  }

  const cancelLeave = () => {
    showConfirmDialog.value = false
    pendingRoute.value = null
  }

  return {
    isDirty,
    showConfirmDialog,
    pendingRoute,
    setDirty,
    setSourceDirty,
    clearDirty,
    checkNavigation,
    confirmLeave,
    cancelLeave,
  }
})
